<template>
  <div
    class="circular-slice"
    :class="{
      'circular-slice-hover': hover && !locked,
      'circular-slice-active': active && !locked
    }"
  >
    <div class="background">
      <div class="menu-slice-accent-1"><slot name="accent-1"></slot></div>
      <div class="menu-slice-accent-2"><slot name="accent-2"></slot></div>
      <div class="menu-slice-body"><slot name="body"></slot></div>
      <div class="accent"><slot name="fill"></slot></div>
      <div class="highlight"><slot name="highlight"></slot></div>
    </div>
    <div
      class="content"
      :style="{
        left: contentX + '%',
        top: contentY + '%',
        width: contentWidth + '%',
        height: contentHeight + '%'
      }"
    >
      <div class="w-full h-full">
        <template v-if="!locked">
          <slot name="icon"></slot>
          <icon-notification
            v-if="showNotification"
            top="0"
            right="0"
            :transform="notificationPosition"
          />
        </template>
        <template v-else>
          <icon-locked class="menu-slice-icon opacity-50" />
        </template>
      </div>
      <template v-if="!locked">
        <div class="menu-slice-label font-bold uppercase">
          <slot name="label"></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import IconNotification from "@/components/icons/IconNotification";
import IconLocked from "@/components/icons/IconLocked";
import { uuid as $uuid } from "vue-uuid";
import Vue from "vue";
export default {
  name: "CircularSlice",
  components: { IconLocked, IconNotification },
  props: {
    showNotification: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    notificationPosition: {
      type: String,
      default: "initial"
    },
    contentX: {
      type: Number,
      default: 0
    },
    contentY: {
      type: Number,
      default: 0
    },
    contentWidth: {
      type: Number,
      default: 0
    },
    contentHeight: {
      type: Number,
      default: 0
    },
    interactionBus: {
      type: Vue,
      default: null
    },
    slice: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      mapName: $uuid.v4(),
      hover: false,
      active: false
    };
  },
  created() {
    if (this.interactionBus != null) {
      this.interactionBus.$on("pointerenter", this.onPointerEnter);
      this.interactionBus.$on("pointerexit", this.onPointerExit);
      this.interactionBus.$on("pointerdown", this.onPointerDown);
      this.interactionBus.$on("pointerup", this.onPointerUp);
    }
  },
  destroyed() {},
  methods: {
    onPointerEnter(slice) {
      if (slice !== this.slice) {
        return;
      }
      this.hover = true;
    },
    onPointerExit() {
      this.hover = false;
      this.active = false;
    },
    onPointerDown(slice) {
      if (slice !== this.slice) {
        return;
      }
      this.hover = true;
      this.active = true;
    },
    onPointerUp() {
      this.active = false;
    }
  }
};
</script>

<style scoped>
.circular-slice,
.circular-slice .background,
.menu-slice-accent-1,
.menu-slice-accent-2,
.menu-slice-body,
.circular-slice .highlight,
.circular-slice .accent {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.circular-slice .content {
  position: absolute;
  transform: translate(-50%, -50%);
}
.circular-slice .highlight {
  opacity: 0;
  transition: opacity 0.1s ease;
}
.circular-slice-c .highlight {
  filter: brightness(0.85);
}
.circular-slice .background,
.circular-slice .menu-slice-accent-1,
.circular-slice .menu-slice-accent-2 {
  transition: transform 0.1s ease-in-out;
}
.circular-slice-hover {
  cursor: pointer;
}
.circular-slice-hover .menu-slice-accent-1 {
  transform: scale(1.01);
}
.circular-slice-hover .menu-slice-accent-2 {
  transform: scale(0.98);
}
.circular-slice-hover .highlight {
  opacity: 0.2;
}
.circular-slice-active .menu-slice-accent-1 {
  transform: scale(1);
}
.circular-slice-active .menu-slice-accent-2 {
  transform: scale(1);
}
.circular-slice-active .background {
  transform: scale(0.95);
}
.circular-slice-active .highlight {
  opacity: 0.5;
}

/deep/ .menu-slice-element,
/deep/ .menu-slice-icon {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.menu-slice-label {
  display: block;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
}
@media (max-width: 380px), (max-height: 600px) {
  .menu-slice-icon {
    position: relative;
    left: 5%;
    width: 90%;
    height: 90%;
  }
  .menu-slice-label {
    font-size: 1.1rem;
    line-height: 1.25em;
  }
}
</style>
